import { BaseContainerModel } from '../base-container.model';
import { bl_wms_picking_discrepancy_RowInterface, bl_wms_picking_discrepancy_RowClass } from '../../dbschema/index';
    
export class WmsPickingDiscrepancyContainer extends BaseContainerModel {
    bl_wms_picking_discrepancy: bl_wms_picking_discrepancy_RowInterface = new bl_wms_picking_discrepancy_RowClass();
}
